import React from "react";

interface props {
  children?: React.ReactNode;
  image?: string;
}
export default function HowToSection({ children, image }: props) {
  return <div className="text-primary-900 dark:text-primary-100">{children}</div>;
}
